<!-- 碧水湾-访客审核 -->
<template>
  <div class="mainArea CVisitorExamine">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <el-tabs v-model="activeName" class="tabList" stretch>
          <el-tab-pane label="待审核" name="first">
            <div class="faceDevice">
              <a href="http://221.181.128.248:20012/iscportal/index.html#/login" target="_blank">人脸设备管理后台</a>
            </div>
            <el-table
              :data="toCheckList"
              stripe
              style="width: 100%">
              <el-table-column
                prop="user"
                label="姓名">
              </el-table-column>
              <el-table-column
                prop="phone"
                label="手机号">
              </el-table-column>
              <el-table-column
                prop="room"
                label="房号">
              </el-table-column>
              <el-table-column
                prop="startTime"
                label="开始时间">
              </el-table-column>
              <el-table-column
                prop="endTime"
                label="结束时间">
              </el-table-column>
              <el-table-column
                label="照片">
                <template slot-scope="scope">
                  <img :src="scope.row.photo" width="100" alt="">
                </template>
              </el-table-column>
              <el-table-column
                label="操作">
                <template slot-scope="scope">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      更多<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="openEdit(scope.$index)">修改</el-dropdown-item>
                      <el-dropdown-item @click.native="agree(scope.$index)">同意</el-dropdown-item>
                      <el-dropdown-item @click.native="refuse(scope.row._id)">拒绝</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <el-button @click="openEdit(scope.$index)" type="text" size="small">修改</el-button>
                  <el-button @click="agree(scope.$index)" type="text" size="small">同意</el-button>
                  <el-button @click="refuse(scope.row._id)" type="text" size="small">拒绝</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="审核记录" name="second">
            <div class="faceDevice">
              <a href="http://221.181.128.248:20012/iscportal/index.html#/login" target="_blank">人脸设备管理后台</a>
            </div>
            <el-table
            :data="checkLogList"
            stripe
            style="width: 100%">
            <el-table-column
              prop="user"
              label="姓名">
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号">
            </el-table-column>
            <el-table-column
              prop="id"
              label="身份证号">
            </el-table-column>
            <el-table-column
              prop="startTime"
              label="开始时间">
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="结束时间">
            </el-table-column>
            <el-table-column
              label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status==='agree'" class="agree" @click="agree">同意</div>
                <div v-if="scope.row.status==='refuse'" class="refuse">拒绝</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              layout="prev, pager, next"
              :total="totalPage"
              @current-change="changePage">
            </el-pagination>
          </div>
          
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 修改信息弹窗 -->
      <el-dialog title="修改信息" :visible.sync="editDio">
        <el-form :model="editform" :rules="modifyRule" ref="form" label-width="100px">
          <el-form-item label="姓名" prop="user">
            <el-input v-model="editform.user" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="id">
            <el-input v-model="editform.id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="editform.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="房号" prop="room">
            <el-input v-model="editform.room" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="开始时间" prop="startTime">
            <el-date-picker
              v-model="editform.startTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker
              v-model="editform.endTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="时间" prop="time">
            <el-date-picker
              v-model="editform.time"
              type="datetimerange"
              align="right"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>

          <el-form-item class="dialog-footer">
            <el-button @click="editDio = false">取 消</el-button>
            <el-button type="primary" @click="onSubmit('form')">确 定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
  </div>
</template>
<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { userApi } from "../../../../static/js/api.js"
  import * as common from "../../../../static/js/common.js"

  export default {
    name: 'CVisitorExamine',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        totalPage:100,
        currentPage:1,
        activeName: 'first',
        toCheckList: [],
        checkLogList: [],
        editform:{
          id:'',
          lastUpdateTime:'',
          createTime:'',
          phone:'',
          photo:'',
          // startTime:'',
          // endTime:'',
          time:'',
          user:'',
          room:'',
          _id:'',
          __v:'',
        },
        editDio:false,
        modifyRule: {
          user: [
            { required: true, message: '名字不能为空', trigger: 'blur' },
            { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
          ],
          id: [
            { required: true, message: '身份证号为必填项', trigger: 'blur' },
            { min: 18, max: 18, message: '长度在 18 个字符', trigger: 'blur' }
          ],
          room: [
            { required: true, message: '请输入您的房号', trigger: 'blur' },
            { min: 0, max: 15, message: '长度在 0 到 15 个字符', trigger: 'blur' }
          ],
          time: [
            { required: true, message: '请选择时间', trigger: 'change' },
          ],
          // startTime: [
          //   { required: true, message: '请选择开始时间', trigger: 'change' },
          // ],
          // endTime: [
          //   { required: true, message: '请选择结束时间', trigger: 'change' },
          // ],
          phone: [
            { pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,message:'请输入正确的手机号'}
          ]
        },

      }
    },
    created: async function () {
      
    },
    mounted: async function() {
      this.getInitData();
    },
    methods: {
      //打开修改
      openEdit(index){
        this.editform.id = this.toCheckList[index].id
        this.editform.lastUpdateTime = this.toCheckList[index].lastUpdateTime
        this.editform.createTime = this.toCheckList[index].createTime
        this.editform.phone = this.toCheckList[index].phone
        this.editform.photo = this.toCheckList[index].photo
        // this.editform.startTime = this.toCheckList[index].startTime
        // this.editform.endTime = this.toCheckList[index].endTime
        this.editform.user = this.toCheckList[index].user
        this.editform.room = this.toCheckList[index].room
        this.editform._id = this.toCheckList[index]._id
        this.editform.__v = this.toCheckList[index].__v
        const arr=[]
        arr.push(this.toCheckList[index].startTime)
        arr.push(this.toCheckList[index].endTime)
        this.editform.time = arr
        this.editDio = true;
      },
      onSubmit(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.updateVisitRequest()
          } else {
            return false;
          }
        });
      },
      //更新访客审核
      async updateVisitRequest(){
        let that = this;
        const editform = that.editform
        editform.startTime = this.editform.time[0];
        editform.endTime = this.editform.time[1];
        delete editform.time
        const dataObj = {
          'modifyForm':editform
        }
        let res = await common.updateVisitRequest(dataObj)
        if(res.meta.code == 200){
          showToast('修改成功！');
          that.getInitData()
          that.editDio = false;
          that.editform={
            id:'',
            lastUpdateTime:'',
            createTime:'',
            phone:'',
            photo:'',
            time:'',
            user:'',
            room:'',
            _id:'',
            __v:'',
          }
        }else{
          showToast(res.meta.message);
        }
      },

      // 获取初始数据
      async getInitData() {
        // 获取申请记录
        let toCheckResult = await common.getVisitRequest();
        if (toCheckResult.meta.code === 200) {
          this.toCheckList = toCheckResult.body;
        }
        // 获取审批记录
        let checkLogResult = await common.getCheckLog(this.currentPage);
        if (checkLogResult.meta.code === 200) {
          this.totalPage = checkLogResult.body.totalPage * 10;
          this.checkLogList = checkLogResult.body.checkLogList;
        }
      },
      // 同意申请
      async agree(index) {
        let that = this;
        let data = {
          'id':that.toCheckList[index]._id,
          'idCard':that.toCheckList[index].id,
          'createTime':that.toCheckList[index].createTime,
          'endTime':that.toCheckList[index].endTime,
          'startTime':that.toCheckList[index].startTime,
          'lastUpdateTime':that.toCheckList[index].lastUpdateTime,
          'phone':that.toCheckList[index].phone,
          'photo':that.toCheckList[index].photo,
          'room':that.toCheckList[index].room,
          'user':that.toCheckList[index].user,
        }
        let agreeResult = await common.agreeRequest(data);
        // console.log(agreeResult)
        if(agreeResult.meta.code == 200) {
          showToast('同意申请');
          this.getInitData();
        }else{
          showToast(agreeResult.meta.message);
        }
      },
      // 拒绝申请
      async refuse(id) {
        let agreeResult = await common.refuseRequest(id);
        if(agreeResult.meta.code === 200) {
          showToast('拒绝申请');
          this.getInitData();
        }
      },
      // 改变当前页
      changePage(data) {
        this.currentPage = data;
        this.getInitData();
      }
    },
    watch: {

    },
  }
</script>
<style lang="scss">
.CVisitorExamine{
  .mainBodyContent{ padding: 0; }
  // tab列表
  .tabList {
    .el-tabs__content{ padding: 20px; }
    // 权限tab
    .list.user {
      .contentRightArea {
        padding: 20px 20px 0 0;
        .searchArea {
          width: 100%;
          .text {
            width: 200px;
            float: left;
            margin-right: 20px;
          }
          .searchBtn {
            float: left;
          }
        }
        .btnArea{
          margin: 20px 0 10px;
        }
      }
      
    }
    .list.auth {
      padding: 24px 32px;
      .addBtn {
        margin-bottom: 24px;
      }
    }
    // tabs标签
    .el-tabs__header {
      width: 100%;
      margin-bottom: 0;
      box-sizing: border-box;
      border-bottom: 1px solid #E4E7ED;
      .el-tabs__nav-wrap {
        padding-left: 20px;
        width: 360px;
      }
      .el-tabs__item {
        font-size: 18px;
      }
    }
  }
  .title {
    font-size: 2em;
    margin: 30px;
  }
  .photo {
    width:100px;
  }
  .agree {
    color:green;
  }
  .refuse {
    color:red;
  }
  .page {
    margin-top: 20px;
    text-align: center;
  }
  .faceDevice {
    margin-bottom: 10px;
    a{
      display: inline-block;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      background: #409EFF;
      color: #fff;
      text-align: center;
      padding: 0 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/CBsw/CVisitorExamine.vue